export default {
  title: 'Preordine',
  categories: {
    title: 'Più popolari',
  },
  header: {
    pickup: 'Ritiro in 5 minuti',
  },
};
